import { render, staticRenderFns } from "./businessAreaDetail.vue?vue&type=template&id=6d6e6f6e&scoped=true"
import script from "./businessAreaDetail.vue?vue&type=script&lang=js"
export * from "./businessAreaDetail.vue?vue&type=script&lang=js"
import style0 from "./businessAreaDetail.vue?vue&type=style&index=0&id=6d6e6f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e6f6e",
  null
  
)

export default component.exports